
export class ContractVolume
{
    id?:number;
    volumeDate?: any;
    invoiceAmount?:number;
   statusMappingId?:number;
    createdBy?: number;
    createdDate?: Date;
    updatedBy?: number;
    updatedDate?: Date;
    isDeleted?: Boolean;
    financeContractVolumeAttachments?:VolumeAttachments[];
    volumeProducts?: any[];
}

  
    
export class VolumeAttachments {
    id: number=0;
    fileName?:string='';
    filePath?:string='';
    financeContractVolumeId: number=0;
    createdBy?: number;
    ceatedDate?: Date;
    updatedBy?: number;
    updatedDate?: Date;
    isDeleted?: Boolean;
    isPrevFileDelete?:Boolean=false;
  }
  
  export class VolumeChildComponents
  {
      contVolumeList:number=1;
      contVolumeEdit:number=2;
      contVolumeView:number=3;
  }

  export class ContracDetails {
    contractDetailId?:number;
    contractStartDate?:any;
    contractEndDate?: any;
  }

  
export class CodeListValues {

    Name?: string;
    Id?: number;
    Code?:string;
    PhoneCode?:string;
  }
 export class ContractVolumeAttachments {
    Id: number=0;
    FileName?:string;
    FilePath?:string;
    ContractVolumeId: number=0;
    CreatedBy?: number;
    CreatedDate?: Date;
    UpdatedBy?: number;
    UpdatedDate?: Date;
    IsDeleted?: Boolean;
  
  }
